// extracted by mini-css-extract-plugin
export default {"contentWrap":"Reset_contentWrap__tlljR","formWrap":"Reset_formWrap__BGQ1b","message":"Reset_message__zC1q-","resetButton":"Reset_resetButton__TyMDT"};